import request from "@/utils/request";

export function getProviderList(params) {
    return request({
        url: '/settings/provider/list',
        method: "get",
        params: params
    });
}